"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _customTranslate = _interopRequireDefault(require("@/libs/flowable/common/customTranslate"));
var _Modeler = _interopRequireDefault(require("bpmn-js/lib/Modeler"));
var _PropertyPanel = _interopRequireDefault(require("./PropertyPanel"));
var _BpmData = _interopRequireDefault(require("@/libs/flowable/BpmData"));
var _init = _interopRequireDefault(require("@/libs/flowable/config/init"));
var _flowable = _interopRequireDefault(require("@/libs/flowable/config/flowable.json"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 汉化
// 引入flowable的节点文件
var _default2 = exports.default = {
  name: 'WorkflowBpmnModeler',
  components: {
    panel: _PropertyPanel.default
  },
  props: {
    xml: {
      type: String,
      default: ''
    },
    users: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    groups: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    categorys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      modeler: null,
      taskList: [],
      zoom: 1
    };
  },
  watch: {
    xml: function xml(val) {
      if (val) {
        this.createNewDiagram(val);
      }
    }
  },
  mounted: function mounted() {
    // 生成实例
    this.modeler = new _Modeler.default({
      container: this.$refs.canvas,
      additionalModules: [{
        translate: ['value', _customTranslate.default]
      }],
      moddleExtensions: {
        flowable: _flowable.default
      }
    });
    // 新增流程定义
    if (!this.xml) {
      this.newDiagram();
    } else {
      this.createNewDiagram(this.xml);
    }
  },
  methods: {
    newDiagram: function newDiagram() {
      this.createNewDiagram((0, _init.default)());
    },
    // 让图能自适应屏幕
    fitViewport: function fitViewport() {
      this.zoom = this.modeler.get('canvas').zoom('fit-viewport');
      var bbox = document.querySelector('.flow-containers .viewport').getBBox();
      var currentViewbox = this.modeler.get('canvas').viewbox();
      var elementMid = {
        x: bbox.x + bbox.width / 2 - 65,
        y: bbox.y + bbox.height / 2
      };
      this.modeler.get('canvas').viewbox({
        x: elementMid.x - currentViewbox.width / 2,
        y: elementMid.y - currentViewbox.height / 2,
        width: currentViewbox.width,
        height: currentViewbox.height
      });
      this.zoom = bbox.width / currentViewbox.width * 1.8;
    },
    // 放大缩小
    zoomViewport: function zoomViewport() {
      var zoomIn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.zoom = this.modeler.get('canvas').zoom();
      this.zoom += zoomIn ? 0.1 : -0.1;
      this.modeler.get('canvas').zoom(this.zoom);
    },
    createNewDiagram: function () {
      var _createNewDiagram = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 将字符串转换成图显示出来
              // data = data.replace(/<!\[CDATA\[(.+?)]]>/g, '&lt;![CDATA[$1]]&gt;')
              data = data.replace(/<!\[CDATA\[(.+?)]]>/g, function (match, str) {
                return str.replace(/</g, '&lt;');
              });
              _context.prev = 1;
              _context.next = 2;
              return this.modeler.importXML(data);
            case 2:
              this.adjustPalette();
              this.fitViewport();
              // this.fillColor()
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.error(_t.message, _t.warnings);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3]]);
      }));
      function createNewDiagram(_x) {
        return _createNewDiagram.apply(this, arguments);
      }
      return createNewDiagram;
    }(),
    // 调整左侧工具栏排版
    adjustPalette: function adjustPalette() {
      try {
        // 获取 bpmn 设计器实例
        var canvas = this.$refs.canvas;
        var djsPalette = canvas.children[0].children[1].children[4];
        var djsPalStyle = {
          width: '130px',
          padding: '5px',
          background: 'white',
          left: '20px',
          borderRadius: 0
        };
        for (var key in djsPalStyle) {
          djsPalette.style[key] = djsPalStyle[key];
        }
        var palette = djsPalette.children[0];
        var allGroups = palette.children;
        allGroups[0].style['display'] = 'none';
        // 修改控件样式
        for (var gKey in allGroups) {
          var group = allGroups[gKey];
          for (var cKey in group.children) {
            var control = group.children[cKey];
            var controlStyle = {
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              width: '100%',
              padding: '5px'
            };
            if (control.className && control.dataset && control.className.indexOf('entry') !== -1) {
              var controlProps = new _BpmData.default().getControl(control.dataset.action);
              control.innerHTML = "<div style='font-size: 14px;font-weight:500;margin-left:15px;'>".concat(controlProps['title'], "</div>");
              for (var csKey in controlStyle) {
                control.style[csKey] = controlStyle[csKey];
              }
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    fillColor: function fillColor() {
      var _this = this;
      var canvas = this.modeler.get('canvas');
      this.modeler._definitions.rootElements[0].flowElements.forEach(function (n) {
        if (n.$type === 'bpmn:UserTask') {
          var completeTask = _this.taskList.find(function (m) {
            return m.key === n.id;
          }) || {
            completed: true
          };
          var todoTask = _this.taskList.find(function (m) {
            return !m.completed;
          });
          var endTask = _this.taskList[_this.taskList.length - 1];
          if (completeTask) {
            canvas.addMarker(n.id, completeTask.completed ? 'highlight' : 'highlight-todo');
            n.outgoing.forEach(function (nn) {
              var targetTask = _this.taskList.find(function (m) {
                return m.key === nn.targetRef.id;
              });
              if (targetTask) {
                canvas.addMarker(nn.id, targetTask.completed ? 'highlight' : 'highlight-todo');
              } else if (nn.targetRef.$type === 'bpmn:ExclusiveGateway') {
                // canvas.addMarker(nn.id, 'highlight');
                canvas.addMarker(nn.id, completeTask.completed ? 'highlight' : 'highlight-todo');
                canvas.addMarker(nn.targetRef.id, completeTask.completed ? 'highlight' : 'highlight-todo');
              } else if (nn.targetRef.$type === 'bpmn:EndEvent') {
                if (!todoTask && endTask.key === n.id) {
                  canvas.addMarker(nn.id, 'highlight');
                  canvas.addMarker(nn.targetRef.id, 'highlight');
                }
                if (!completeTask.completed) {
                  canvas.addMarker(nn.id, 'highlight-todo');
                  canvas.addMarker(nn.targetRef.id, 'highlight-todo');
                }
              }
            });
          }
        } else if (n.$type === 'bpmn:ExclusiveGateway') {
          n.outgoing.forEach(function (nn) {
            var targetTask = _this.taskList.find(function (m) {
              return m.key === nn.targetRef.id;
            });
            if (targetTask) {
              canvas.addMarker(nn.id, targetTask.completed ? 'highlight' : 'highlight-todo');
            }
          });
        }
        if (n.$type === 'bpmn:StartEvent') {
          n.outgoing.forEach(function (nn) {
            var completeTask = _this.taskList.find(function (m) {
              return m.key === nn.targetRef.id;
            });
            if (completeTask) {
              canvas.addMarker(nn.id, 'highlight');
              canvas.addMarker(n.id, 'highlight');
              return;
            }
          });
        }
      });
    },
    // 对外 api
    getProcess: function getProcess() {
      var element = this.getProcessElement();
      var description;
      if (element.documentation !== undefined && element.documentation !== null) {
        description = element.documentation[0].text;
      }
      return {
        id: element.id,
        name: element.name,
        category: element.$attrs['flowable:processCategory'],
        description: description
      };
    },
    getProcessElement: function getProcessElement() {
      var rootElements = this.modeler.getDefinitions().rootElements;
      for (var i = 0; i < rootElements.length; i++) {
        if (rootElements[i].$type === 'bpmn:Process') return rootElements[i];
      }
    },
    saveXML: function () {
      var _saveXML = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var download,
          _yield$this$modeler$s,
          xml,
          _args2 = arguments,
          _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              download = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              _context2.prev = 1;
              _context2.next = 2;
              return this.modeler.saveXML({
                format: true
              });
            case 2:
              _yield$this$modeler$s = _context2.sent;
              xml = _yield$this$modeler$s.xml;
              if (download) {
                this.downloadFile("".concat(this.getProcessElement().name, ".bpmn20.xml"), xml, 'application/xml');
              }
              return _context2.abrupt("return", xml);
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
              console.log(_t2);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function saveXML() {
        return _saveXML.apply(this, arguments);
      }
      return saveXML;
    }(),
    saveImg: function () {
      var _saveImg = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var type,
          download,
          _yield$this$modeler$s2,
          svg,
          _args3 = arguments,
          _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              type = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 'svg';
              download = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;
              _context3.prev = 1;
              _context3.next = 2;
              return this.modeler.saveSVG({
                format: true
              });
            case 2:
              _yield$this$modeler$s2 = _context3.sent;
              svg = _yield$this$modeler$s2.svg;
              if (download) {
                this.downloadFile(this.getProcessElement().name, svg, 'image/svg+xml');
              }
              return _context3.abrupt("return", svg);
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
              console.log(_t3);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function saveImg() {
        return _saveImg.apply(this, arguments);
      }
      return saveImg;
    }(),
    save: function () {
      var _save = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var process, xml, svg, result;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              process = this.getProcess();
              _context4.next = 1;
              return this.saveXML();
            case 1:
              xml = _context4.sent;
              _context4.next = 2;
              return this.saveImg();
            case 2:
              svg = _context4.sent;
              result = {
                process: process,
                xml: xml,
                svg: svg
              };
              this.$emit('save', result);
              window.parent.postMessage(result, '*');
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }(),
    openBpmn: function openBpmn(file) {
      var _this2 = this;
      var reader = new FileReader();
      reader.readAsText(file, 'utf-8');
      reader.onload = function () {
        _this2.createNewDiagram(reader.result);
      };
      return false;
    },
    downloadFile: function downloadFile(filename, data, type) {
      var a = document.createElement('a');
      var url = window.URL.createObjectURL(new Blob([data], {
        type: type
      }));
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
};